import AreasAddPage from './AreasAddPage';

export default AreasAddPage;
